export default __webpack_public_path__ + "static/media/pcard6.cdb0562f.png";